import { createFeature, createReducer, on } from '@ngrx/store';
import { ColorModeEnum, ENGLISH, FavoriteClientIds, Language } from '@qvs/core';
import * as fromActions from './preference.actions';
import { xor } from 'lodash-es';

interface Preference {
  lang: Language;
  colorMode: ColorModeEnum;
  crmFavoriteClientIds: FavoriteClientIds;
}

const initialState: Preference = {
  lang: ENGLISH,
  colorMode: ColorModeEnum.LIGHT,
  crmFavoriteClientIds: []
};

const reducer = createReducer(
  initialState,
  on(fromActions.changeLanguage, (state, { lang }) => ({ ...state, lang })),
  on(fromActions.changeColorMode, (state, { colorMode }) => ({ ...state, colorMode })),
  on(fromActions.toggleCrmFavoriteClientId, (state, { clientId }) => {
    const crmFavoriteClientIds = xor(state.crmFavoriteClientIds, [clientId]);
    return {
      ...state,
      crmFavoriteClientIds
    };
  })
);

export const preferenceFeature = createFeature({
  name: 'preference',
  reducer
});

export type State = Preference;

export const preferenceFeatureKey = preferenceFeature.name;
export const { selectColorMode, selectLang, selectCrmFavoriteClientIds } = preferenceFeature;
